import React from "react";
import { useNavigate } from "react-router-dom";

import "./footer.css";

function Footer() {
  const navigate = useNavigate();
  return (
    <section className="footer">
      <hr className="footer-seperator" />

      <section className="footer-info">
        <section className="footer-info-left">
          <div className="footer-div-outer">
            <section className="footer-info__name">We Together</section>
          </div>
          <div>
            <button
              onClick={() => {
                navigate("/auth");
              }}
              className="buttonz"
            >
              Get Started
            </button>
          </div>
        </section>
        <section className="footer-info-center">
          <section className="footer-info__terms">
            Terms and Conditions
            <br />
            Copyright
          </section>
        </section>

        <section className="footer-social-media">
          <a
            href="https://github.com/redbrickhacks/redbrickhacks-2022-submission-midnight-hackers"
            target="_blank"
            rel="noopener noreferrer"
          >
            Github
          </a>
        </section>
      </section>
      <hr className="footer-seperator" />
    </section>
  );
}

export default Footer;
